module.exports = __webpack_public_path__ + "static/media/dashboard_add_collaborator.79067b94.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/dashboard_add_collaborator.mp4
// module id = 272
// module chunks = 0